module.exports = __webpack_public_path__ + "static/media/CV.9a3c3096.pdf";